<template>
  <div class="flex flex-col min-h-screen bg-black">
    <Header />
    <main class="flex-grow">
      <router-view />
    </main>
  </div>
</template>

<script>
import Header from './components/Header.vue'
import { useAdStore } from './store/adStore'
import { useParentUrlListener } from './composables/useParentUrlListener'
import { onMounted, onBeforeUnmount, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'

export default {
  components: {
    Header,
  },
  setup() {
    const adStore = useAdStore()
    const router = useRouter()
    const route = useRoute()
    const { parentUrl, parentUrlVersion } = useParentUrlListener()

    const syncRouteFromParentUrl = (urlValue) => {
      if (!urlValue) return

      let url
      try {
        url = new URL(urlValue)
      } catch (err) {
        return
      }

      const query = Object.fromEntries(url.searchParams.entries())
      const videoSlug = query.video_slug || query.videoSlug

      if (videoSlug) {
        const pathname = url.pathname.toLowerCase()
        let partnerId = route.params.partnerId;
        
        if (!partnerId) {
          partnerId = url.pathname.split('/').filter(Boolean)?.[0];
        }
        
        let targetPath
        if (pathname.includes('/video') && !pathname.includes('/play')) {
          targetPath = partnerId ? `/${partnerId}/video` : '/video'
        } else {
          targetPath = partnerId ? `/${partnerId}/play` : '/play'
        }

        const targetQuery = { videoSlug }
        Object.keys(query).forEach(key => {
          if (key !== 'video_slug' && key !== 'videoSlug') {
            targetQuery[key] = query[key]
          }
        })

        const resolved = router.resolve({ path: targetPath, query: targetQuery })
        if (resolved?.fullPath === route.fullPath) return
        router.replace(resolved.fullPath)
        return
      }
      return;
      
    }

    watch(parentUrlVersion, () => {
      syncRouteFromParentUrl(parentUrl.value)
    })

    onMounted(() => {
      adStore.startInterval()
    })
    
    onBeforeUnmount(() => {
      adStore.stopInterval()
    })

    return {
      adStore
    }
  }
}
</script>

<style>

</style>
